import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { fetchUserNames } from '../api/storeUsers';
import { storeAuth } from '../api/client';
import { useAuth } from '../contexts/AuthContext';

/**
 * Loads the full providerId → name map from GET /api/v1/store/users/names.
 */
export const useUserNames = () => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const [storeReady, setStoreReady] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || authLoading) {
      setStoreReady(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const token = await storeAuth.getStoreBearerForRequest();
      if (!cancelled) {
        setStoreReady(Boolean(token));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, authLoading]);

  return useQuery<Record<string, string>>(
    'storeUserNames',
    fetchUserNames,
    {
      enabled: isAuthenticated && !authLoading && storeReady,
      staleTime: 5 * 60 * 1000,
      retry: 2,
    }
  );
};
